module.exports = __webpack_public_path__ + "static/media/wizards-noCirc.4366f925.svg";